export const SHIPMENTS_ERROR_STATUS = {
  differentRegion: 422
}

export const SHIPMENTS_EXPRESS_MODALITIES = ['express', 'marketplace_express']
